<template>
  <div class="system-settings app-info-list app-region blank-t-v blank-b-v blank-l-h blank-r-h">
    <a-row type="flex" align="middle">
      <a-col>用户协议</a-col>
      <a-col>
        <a-row type="flex" align="middle">
          <a-col v-html="noteOne"></a-col>
          <a-col>
            <a-button type="link" @click="showModalOne">修改</a-button>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-row type="flex" align="middle">
      <a-col>隐私策略</a-col>
      <a-col>
        <a-row type="flex" align="middle">
          <a-col v-html="noteTwo"></a-col>
          <a-col>
            <a-button type="link" @click="showModalTwo">修改</a-button>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-row type="flex" align="middle">
      <a-col>关于我们</a-col>
      <a-col>
        <a-row type="flex" align="middle">
          <a-col v-html="noteThree"></a-col>
          <a-col>
            <a-button type="link" @click="showModalThree">修改</a-button>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-modal :title="modalOne.title" :confirm-loading="modalOne.loading" v-model="modalOne.show" @ok="confirmModalOne" width="50%" destroy-on-close>
      <editor name="editorOne" v-model="modalOne.note"></editor>
    </a-modal>
    <a-modal :title="modalTwo.title" :confirm-loading="modalTwo.loading" v-model="modalTwo.show" @ok="confirmModalTwo" width="50%" destroy-on-close>
      <editor name="editorTwo" v-model="modalTwo.note"></editor>
    </a-modal>
    <a-modal :title="modalThree.title" :confirm-loading="modalThree.loading" v-model="modalThree.show" @ok="confirmModalThree" width="50%" destroy-on-close>
      <editor name="editorThree" v-model="modalThree.note"></editor>
    </a-modal>
  </div>
</template>

<script>
  import SystemConfigService from '@/io/system_config.js';

  export default {
    name: 'SystemConfig',
    data() {
      return {
        noteOne: null,
        noteTwo: null,
        noteThree: null,
        modalOne: {
          note: null,
          title: '修改用户协议',
          show: false,
          loading: false
        },
        modalTwo: {
          note: null,
          title: '修改隐私策略',
          show: false,
          loading: false
        },
        modalThree: {
          note: null,
          title: '关于我们',
          show: false,
          loading: false
        },
      }
    },
    mounted() {
      this.initDataOne();
      this.initDataTwo();
      this.initDataThree();
    },
    methods: {
      initDataOne() {
        SystemConfigService.get('owner_userAgreement').then(res => {
          this.noteOne = res.value;
        }).catch(err => {});
      },
      initDataTwo() {
        SystemConfigService.get('owner_privacyPolicy').then(res => {
          this.noteTwo = res.value;
        }).catch(err => {});
      },
      initDataThree() {
        SystemConfigService.get('owner_userAbout').then(res => {
          this.noteThree = res.value;
        }).catch(err => {});
      },
      showModalOne() {
        this.modalOne.show = true;
        this.modalOne.note = this.noteOne;
      },
      showModalTwo() {
        this.modalTwo.show = true;
        this.modalTwo.note = this.noteTwo;
      },
      showModalThree() {
        this.modalThree.show = true;
        this.modalThree.note = this.noteThree;
      },
      confirmModalOne() {
        this.modalOne.loading = true;
        SystemConfigService.set('owner_userAgreement', this.modalOne.note).then(() => {
          this.$afterFormSubmit('编辑成功', () => {
            this.initDataOne();
          });
        }).catch(err => {}).finally(() => {
          this.modalOne.show = false;
          this.modalOne.loading = false;
        });
      },
      confirmModalTwo() {
        this.modalTwo.loading = true;
        SystemConfigService.set('owner_privacyPolicy', this.modalTwo.note).then(() => {
          this.$afterFormSubmit('编辑成功', () => {
            this.initDataTwo();
          });
        }).catch(err => {}).finally(() => {
          this.modalTwo.show = false;
          this.modalTwo.loading = false;
        });
      },
      confirmModalThree() {
        this.modalThree.loading = true;
        SystemConfigService.set('owner_userAbout', this.modalThree.note).then(() => {
          this.$afterFormSubmit('编辑成功', () => {
            this.initDataThree();
          });
        }).catch(err => {}).finally(() => {
          this.modalThree.show = false;
          this.modalThree.loading = false;
        });
      }
    },
  }
</script>

<style lang="less" scoped>

</style>